import { useCallback, useState } from "react";
import useAuth from "./use-auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function useHttp(isLoading = true) {
  const [loading, setLoading] = useState(isLoading);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const navigate = useNavigate();
  const AuthCTX = useAuth();

  const request = useCallback(
    async ({ url, values, isFile, isMulty, ignoreError }) => {
      isFile && setUploadProgress(0);
      isFile && setIsUploading(true);
      !isMulty && setLoading(true);
      var res = await url(values);
      !isMulty && setLoading(false);
      isFile && setIsUploading(false);
      isFile && setUploadProgress(100);

      if (ignoreError) {
        return res;
      }

      const code = res.data?.code || res?.status;

      if (!res.ok || (code < 200 && code > 300)) {
        const { type, message } = res;
        toast[type || "error"](message ?? "با خطا مواجه شده است", {
          autoClose: 3000,
          position: "top-center",
        });
        return false;
      }

      return res.data;
    },
    []
  );

  return {
    request,
    loading,
    setLoading,
    uploadProgress,
    setUploadProgress,
    isUploading,
  };
}
